import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { AreaService } from "app/service/cliente/area.service";

export interface FormType {
  clientId: number;
  alfrescoModelId: number;
  areaId: number;
  desc: string;
  name: string;
  primaryTypeId: number;
  title: string;
}
@Component({
  selector: "app-node-edit-dialog",
  templateUrl: "./node-edit-dialog.component.html",
  styleUrls: ["./node-edit-dialog.component.scss"],
})
export class NodeEditDialogComponent implements OnInit {
  public nodeForm: FormGroup;
  isLoading = true;
  models: any[];
  isEdit = false;
  areas: any[];
  nodesByModel: any[];
  selectedArea = null;
  selectedModel: {
    id: number;
    prefix: string;
  } = null;
  selectedPrimaryType = null;
  areasTipo = [];
  areasFiltered = [];
  nodesFiltered = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<NodeEditDialogComponent>,
    public areaService: AreaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private configPastaService: ConfigurarPastaServiceService
  ) {
    if(this.data.clientId) {
      this.listarAreas();
    }
    this.listarModelosInterface();
    if (this.data.node) this.isEdit = true;
  }

  ngOnInit() {
    this.nodeForm = this.fb.group({
      name: [
        {
          value: this.isEdit ? this.data.node.name : null,
          disabled: true,
        },
        Validators.required,
      ],
      alfrescoModel: [!this.isEdit ? this.selectedModel : null],
      title: [
        {
          value: this.isEdit ? this.data.node.title : null,
          disabled: this.isEdit ? false : true,
        },
        Validators.required,
      ],
      desc: [
        this.isEdit ? this.data.node.description : null,
        Validators.required,
      ],
      areaId: [null],
      primaryTypeId: [!this.isEdit ? this.selectedPrimaryType : null],
    });
    console.log(this.data, this.isEdit);
    if (!this.isEdit) {
      this.nodeForm.get("alfrescoModel").setValidators(Validators.required);
      this.nodeForm.get("primaryTypeId").setValidators(Validators.required);
    }
  }

  listarAreas() {
    this.areaService.getDescricaoAreasCliente(this.data.clientId).subscribe(
      (data) => {
        this.areas = data;
        this.areas.forEach((element) => {
          this.areasTipo.push({
            value: element.id,
            viewValue: element.descricao,
            sigla: element.sigla,
          });
        });
        console.log(this.areasTipo);
        this.areasFiltered = [...this.areasTipo];
        // this.isLoading = false;
      },
      (err) => {
        this.openSnackBar("Ocorreu um erro ao listar áreas, tente novamente em instantes", true);
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  listarModelos() {
    this.configPastaService.getModelosAlfresco().subscribe(
      (dados) => {
        this.models = dados;

        if (dados.length === 0) {
          this.openSnackBar("Você não possui modelos vinculados", true);
        }
        this.isLoading = false;
      },
      (err) => {
        console.error(err);
        this.openSnackBar("Ocorreu um erro ao listar modelos", true);
        this.isLoading = false;
      }
    );
  }

  listarModelosInterface() {
    this.configPastaService.getModelosAlfrescoInterafece().subscribe(
      (dados) => {
        this.models = dados;

        if (dados.length === 0) {
          this.openSnackBar("Você não possui modelos vinculados", true);
        }
        this.isLoading = false;
      },
      (err) => {
        console.error(err);
        this.openSnackBar("Ocorreu um erro ao listar modelos", true);
        this.isLoading = false;
      }
    );
  }

  listarNodesByModel(modelId: number) {
    this.configPastaService.getNodesByModelId(modelId).subscribe(
      (data) => {
        this.nodesByModel = data;
        this.nodesFiltered = [...data];
        if (data.length === 0) {
          this.openSnackBar("Este modelo não possui tipos documentais", true);
        } else {
          this.nodeForm.get("title").enable();
        }
      },

      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onEditNode() {
    if (this.nodeForm.valid) {
      this.isLoading = true;
      const nodeToSave = { ...this.data.node };
      nodeToSave.title = this.nodeForm.get("title").value;
      nodeToSave.description = this.nodeForm.get("desc").value;

      this.configPastaService.editNode(nodeToSave).subscribe(
        (data) => {
          this.configPastaService.isChangedNode.next();
          this.openSnackBar("Tipo documental atualizado com sucesso!", false);
          this.isLoading = false;
        },
        (err) => {
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro ao atualizar tipo documental, tente novamente em alguns instantes",
            true
          );
          this.isLoading = false;
        }
      );
    } else {
      this.openSnackBar("Preencha os campos obrigatórios", true);
    }
  }

  formatNodeTitle(title: string) {
    return `(${this.selectedModel.prefix.toUpperCase()}) ${title}`
  }

  onCreateNode() {
    if (this.nodeForm.valid && ((this.selectedArea && this.selectedArea.sigla) || !this.data.clientId)) {
      this.isLoading = true;

      const nodeToCreate: FormType = { ...this.nodeForm.value };

      nodeToCreate.title = this.formatNodeTitle(nodeToCreate.title);

      nodeToCreate.clientId = Number(this.data.clientId);
      nodeToCreate.alfrescoModelId =
        this.nodeForm.get("alfrescoModel").value.id;

      nodeToCreate.name = this.nodeForm.get("name").value;

      console.log(nodeToCreate, this.nodeForm);

      this.configPastaService.createNewNode(nodeToCreate).subscribe(
        () => {
          this.configPastaService.isChangedNode.next();
          this.openSnackBar("Tipo documental criado com sucesso!", false);
          this.isLoading = false;
          this.nodeForm.get('name').reset();
          this.nodeForm.get('title').reset();
          this.nodeForm.get('desc').reset();
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            err.error || "Ocorreu um erro ao criar tipo documental, tente novamente em alguns instantes",
            true
          );
        }
      );
    } else {
      this.openSnackBar(
        this.nodeForm.valid
          ? "É preciso cadastrar uma sigla para a área selecionada antes de prosseguir"
          : "Preencha os campos obrigatórios",
        true
      );
    }
  }

  formatTypeName(name) {
    let wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " ",
    ];
    let re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");

    let nameFormated = name
      .slice(name.indexOf(":") + 1, name.length)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");

    nameFormated = this.nodeForm
      .get("alfrescoModel")
      .value.prefix.concat(":", this.data.clientId && this.selectedArea && this.selectedArea.sigla ? this.selectedArea.sigla.toLowerCase() : '', nameFormated);

    this.nodeForm.get("name").setValue(nameFormated);
  }

  onAreaSelectionChange() {
    this.selectedArea = this.areasTipo.find(
      (el) => el.value === this.nodeForm.get("areaId").value
    );

    if (!this.selectedArea.sigla) {
      this.openSnackBar(
        "É preciso cadastrar uma sigla para a área selecionada antes de prosseguir",
        true
      );
    }

    console.log(this.selectedArea);
  }

  onModelSelectionChange() {
    console.log(this.nodeForm.get("alfrescoModel").value);
    this.selectedModel = this.nodeForm.get("alfrescoModel").value;

    if (this.nodeForm.get("name").value) {
      this.formatTypeName(this.nodeForm.get("name").value);
    }

    this.listarNodesByModel(this.nodeForm.get("alfrescoModel").value.id);
  }

  onPrimTypeSelectionChange() {
    console.log(this.selectedPrimaryType);
  }

  onSearch(value: string, mode: string) {
    const filter = value.toLowerCase();

    switch (mode) {
      case "AREA":
        this.areasFiltered = this.areasTipo.filter((area) =>
          area.viewValue
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(filter)
        );
        break;
      case "TIPOPRIMARIO":
        this.nodesFiltered = this.nodesByModel.filter((node) =>
          node.title
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(filter)
        );
        break;
      default:
        break;
    }
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/node-edit-dialog/node-edit-dialog.component.ts